import React, { Suspense, useCallback, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Redirect, Route, useHistory, useLocation } from "react-router-dom";

import commonClient from "../../apis/commonClient";
import userClient from "../../apis/userClient";
import * as actions from "../../redux/actions";

import $ from "jquery";
import Cookies from "js-cookie";
import authenticationClient from "../../apis/authenticationClient";
import Loading from "../../components/ReactBootstrap/LoaderSpinner/Loading";
import { setLocale } from "../../constants/SensolusMoment";
// import timeline library before setLocale. So, need to import Timeline at App level
import { useOrg } from "../../contexts/OrgContext";
import { useCustomBranding } from "../../pages/CustomBranding/useCustomBranding";
import {
  WebSocketProvider,
  useWebSocket,
} from "../../contexts/WebSocketContext";
import { adminRoutes } from "../App/routes";
import Header from "./Header/Header";
import HelpSidebar from "./HelpSidebar/HelpSidebar";
import Sidebar from "./Sidebar/Sidebar";
import TermOfUse from "./TermOfUse/TermOfUse";
import ImpersonateHeader from "./Header/ImpersonateHeader";

import SensolusWhileLogoIcon from "@images/sensolus/sensolus_logo_white.svg";
import SensolusLogoIcon from "@images/sensolus/sensolus_logo.svg";
import { languageSelector } from "@/redux/selectors";
import businessIntelligenceClient from "@/apis/businessIntelligenceClient";
import SntDialog from "@/components/SntDialog/SntDialog";
import NotificationSidebar from "@/cleanup/containers/NotificationSidebar/NotificationSidebar";
import { useAppLanguage } from "@/contexts/AppLanguageContext";

const AppLayoutContent = () => {
  let [state, setState] = useState({
    loading: true,
    redirect: false,
  });

  const setCookie = useCookies(["_csrf"])[1];
  const sensolusFullScreen = Cookies.get("sensolus-full-screen");
  const dispatch = useDispatch();
  const loginInfo = useSelector((state) => state.user, shallowEqual);
  let { permissionsMap } = loginInfo;
  const history = useHistory();
  const location = useLocation();
  const { updateOrg } = useOrg();
  const [reloadCount, setReloadCount] = useState(0);
  const [isShowTermOfUse, setIsShowTermOfUse] = useState(false);
  const [impersonateUser, setImpersonateUser] = useState();

  // WebSocket integration
  const { connect, disconnect, isConnected, connectionStatus } = useWebSocket();

  const language = useSelector(languageSelector);
  const { appLanguage, setAppLanguage } = useAppLanguage();

  const { menuType, dashboardNotification, preventSidebar } = useSelector(
    (state) => state.all,
    shallowEqual
  );

  const { getHomeLogoImgSrc, getAdminLogoImgSrc } = useCustomBranding();

  useEffect(() => {
    let src = null;
    if (loginInfo && loginInfo.custumInfo) {
      if (menuType === "MAIN") {
        src = getHomeLogoImgSrc(loginInfo.custumInfo);
      } else {
        src = getAdminLogoImgSrc(loginInfo.custumInfo);
      }
    }
    if (!src) {
      if (menuType === "MAIN") {
        src = SensolusWhileLogoIcon;
      } else {
        src = SensolusLogoIcon;
      }
    }
    dispatch(actions.setLogoPath(src));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginInfo, menuType]);

  useEffect(() => {
    if (loginInfo) {
      if (loginInfo?.organisation?.organisationType === "NORMAL") {
        updateOrg(loginInfo.organisation.id);
      }

      setImpersonateUser(loginInfo.impersonateData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginInfo]);

  const reloadPage = useCallback(() => {
    // for react pages, changing a prop forces remount
    // implement custom reload by useEffect on reload prop
    setReloadCount((prevReload) => prevReload + 1);
  }, []);

  useEffect(() => {
    if (appLanguage) {
      // Change the lang attribute of the <html> element
      document.documentElement.lang =
        appLanguage === "en-gb" ? "en" : appLanguage;
    }
  }, [appLanguage]);

  useEffect(() => {
    let csrfName = sessionStorage.getItem("csrf_name");
    let csrf = Cookies.get(csrfName);

    authenticationClient
      .getUserInfo()
      .then((data) => {
        data.data.csrfToken = csrf;
        let loginData = data.data;

        dispatch(actions.loginSuccess(loginData));
        let languageKey = loginData.language;
        setAppLanguage(languageKey);
        userClient.getLanguage(languageKey).then((data) => {
          let _lang = data.data;
          dispatch(actions.updateLanguage(_lang));
          setLocale(languageKey, loginData.timezone);
          setState({ loading: false });

          // Connect WebSocket immediately with available tokens
          console.log("Connecting WebSocket after authentication...");
          connect(loginData.token, csrf);

          commonClient
            .getMessageOnUserPage()
            .then((data) => {
              dispatch(actions.updateMessage(data.data));
            })
            .catch(() => {});

          if (loginData.termsOfUseInfo && !loginData.termsOfUseInfo.ok) {
            setIsShowTermOfUse(true);
          }
        });
      })
      .catch(() => {
        setState({ loading: false, redirect: true });
      });

    let lastPathName = "";
    let listen = history.listen((location, action) => {
      let newPath = location.pathname + location.search;
      if (lastPathName !== newPath) {
        lastPathName = newPath;
        dispatch(actions.addHistoryCount());
      }
    });

    return () => {
      listen();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCookie, dispatch, history]);

  // WebSocket connection status monitoring
  useEffect(() => {}, [isConnected, connectionStatus]);

  // Cleanup WebSocket on component unmount
  useEffect(() => {
    return () => {
      console.log("AppLayout unmounting, disconnecting WebSocket...");
      disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state.loading) {
    return null;
  }

  if (state.redirect) {
    if (
      location.pathname &&
      location.pathname.length > 0 &&
      location.pathname !== "/tracked_assets" &&
      location.pathname !== "/"
    ) {
      return (
        <Redirect
          to={
            "/login" +
            (location.search && location.search.length > 0
              ? location.search + "&"
              : "?") +
            "redirect_to=" +
            location.pathname
          }
        />
      );
    }
    return <Redirect to={"/login"} />;
  }

  const getRoute = (obj, key) => {
    let component = obj;
    if (
      permissionsMap &&
      !(
        permissionsMap["DEVICE_METADATA_VIEW"] ||
        permissionsMap["DEVICE_UPDATE"]
      ) &&
      obj.path === "/tracked_assets"
    ) {
      component = {
        component: () => {
          return <></>;
        },
      };
    }

    return (
      <Route
        key={key}
        path={obj.path}
        exact={obj.exact}
        render={() => (
          <Suspense fallback={<Loading />}>
            <div key={reloadCount}>
              {React.cloneElement(component.component(), {
                reload: reloadCount,
              })}
            </div>
          </Suspense>
        )}
      />
    );
  };

  const listMenu = adminRoutes.map((obj, key) => {
    return getRoute(obj, key);
  });
  const helpSideBarCloseEvent = (e) => {
    e.preventDefault();
    $("#help-side-info-panel").hide();
  };

  const saveDashboard = (data) => {
    let descriptor = JSON.stringify({ widgets: data.widgets });
    businessIntelligenceClient
      .update(data.id, { descriptor: descriptor, dashboardType: "PLATFORM" })
      .then((data) => {
        dispatch(actions.setDashboardNotification(null));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div
      className={`wrapper  ${sensolusFullScreen && "full-screen-mode"} ${
        impersonateUser ? "impersonate-mode" : ""
      }`}
    >
      {!preventSidebar && !sensolusFullScreen ? (
        <>
          <ImpersonateHeader
            impersonateUser={impersonateUser}
            onLeaveClicked={() => {
              setImpersonateUser(null);
            }}
          />

          <Header reloadPage={reloadPage} />
          <Sidebar />
        </>
      ) : (
        <></>
      )}

      {!preventSidebar ? (
        <div className="main-panel snt-main-panel">
          <div className="content">
            <div className="container-fluid">{listMenu}</div>
          </div>
        </div>
      ) : (
        <></>
      )}

      <div
        id="help-side-info-panel"
        className="right-sidebar sidebar-help side-info-panel slideInRight animated snt-right-sidebar"
        style={{ display: "none" }}
      >
        <HelpSidebar
          orgId={loginInfo.organisation.id}
          closeEvent={helpSideBarCloseEvent}
        />
      </div>

      <NotificationSidebar />

      <TermOfUse
        isShow={isShowTermOfUse}
        setIsShow={setIsShowTermOfUse}
        loginInfo={loginInfo}
      ></TermOfUse>

      {dashboardNotification && (
        <SntDialog
          isShow={true}
          onSave={() => saveDashboard(dashboardNotification)}
          onClose={() => {
            dispatch(actions.setDashboardNotification(null));
          }}
          title={"Update the changed dashboard settings"}
          saveTxt={language.save_key}
          closeTxt={language.cancel_key}
          backdrop={"static"}
        >
          {() => {
            return (
              <div>
                Do you want to save the changes made to the settings of{" "}
                <b>{dashboardNotification.title}</b> dashboard?
              </div>
            );
          }}
        </SntDialog>
      )}
    </div>
  );
};

// Main AppLayout component wrapped with WebSocketProvider
const AppLayout = () => {
  return (
    <WebSocketProvider>
      <AppLayoutContent />
    </WebSocketProvider>
  );
};

export default AppLayout;
